export default {
    meetingHistory: '/api/web/v3/meeting/viewhistory',
    informationHistory: '/api/web/v2/meeting/information/viewhistory',
    productionHistory: '/api/web/v3/production/viewhistory',
    clearHistory: '/api/web/v3/meeting/clearhistory'
}